export default {
  padding: 0,
  border: "1px solid rgb(226, 226, 226)",
  backgroundColor: "#FBFBFB",
  marginBottom: "20px"
};
